import { keyframes, css } from 'styled-components';
import { TDirection } from '../tokens/types';

const translateProp = {
    up: 'translateY(-100%)',
    down: 'translateY(100%)',
    left: 'translateX(-100%)',
    right: 'translateX(100%)'
};

export const fromDirection = (direction: TDirection = 'right') => keyframes`
    from {
        transform: ${translateProp[direction]};
    }
    to {
        transform: translate(0, 0);
    }
`;

export const fadeIn = () => keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

export const fadeInOut = keyframes`
    0% {
        opacity: 0;
    }
    20% {
        opacity: 1;
    }
    80% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
`;

export const dissolve = (direction: TDirection = 'up') => keyframes`
    from {
        transform: translate(0, 0);
        opacity: 1;
    }
    to {
        transform: ${translateProp[direction]};
        opacity: 0;
    }
`;

export const spin = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`;

export const skBounceDelay = keyframes`
    0%,
    80%,
    100% { 
        transform:scale(0);
        opacity:0
    }
    40% {
        transform:scale(1);
        opacity:1
    }
`;

export const transition = (
    property = 'all',
    durationEffect = '0.15s',
    timingFunction = 'ease-in'
) => css`
    transition: ${property} ${durationEffect} ${timingFunction};
`;

// pass specific properties to overwrite transition all
export const transitionProperties = properties =>
    css`
        transition-property: ${properties};
    `;

export function hoverTransition(
    property: string,
    currVal: string,
    hoverVal: string,
    durationEffect?: string,
    timingFunction?: string,
    includeFocus: boolean = true
) {
    return css`
        ${`${property}: ${currVal};`}
        ${transition(property, durationEffect, timingFunction)}

        &:hover,
        &:focus-visible {
            ${`${property}: ${hoverVal};`}
        }

        ${includeFocus &&
        css`
            &:focus {
                ${`${property}: ${hoverVal};`}
            }
        `}
    `;
}

export const twinkle = keyframes`
    50% {
        transform: scale(0.5);
        opacity: 0.5;
    }
`;

export const shine = keyframes`
    to {
        background-position-x: -200%;
    }
`;

export const bounceFromTop = keyframes`   
    0% {
        transform:${translateProp.up};
    }
    65% {
        transform: translateY(-56px);
        animation-timing-function: ease-in;
    }
    82% {
         transform: translateY(-32px);
         animation-timing-function: ease-in;
    }
    93% {
        transform: translateY(-12px);
        animation-timing-function: ease-in;
    }
    55%,
    75%,
    87%,
    100% {
        transform: translateY(0px);
        animation-timing-function: ease-out;
    }
`;
